import { GLOBAL_STYLE_SHEET_ID } from '@/constants';
import { log } from '@/utils';

export const createScopedStylesheet = async (
  url: string,
): Promise<CSSStyleSheet | string> => {
  const supportsConstructableSheets =
    'adoptedStyleSheets' in Document.prototype &&
    'replaceSync' in CSSStyleSheet.prototype;

  const res = await fetch(url);

  if (!res.ok) {
    throw new Error(`Failed to load stylesheet: ${url}`);
  }

  const cssText = await res.text();

  if (!supportsConstructableSheets) {
    return cssText;
  }

  const sheet = new CSSStyleSheet();
  sheet.replaceSync(cssText);
  return sheet;
};

export const injectGlobalStyleSheet = () => {
  if (document.getElementById(GLOBAL_STYLE_SHEET_ID)) {
    log.warn('Stylesheet already injected. Skipping injection.');
    return;
  }

  const css = `
    [data-its-loading] {
      display: block !important;
    }
  `;

  const style = document.createElement('style');

  style.id = GLOBAL_STYLE_SHEET_ID;
  style.textContent = css;

  const head = document.head;

  if (head) {
    head.appendChild(style);

    log.info('Stylesheet injected successfully!');
  } else {
    log.error('The document head could not be found.');
  }
};
